<template>
  <div
    class="discovery-stats-chart-legend"
    :class="{ 'discovery-stats-chart-legend--inactive': !isActive }"
    v-on="$listeners"
  >
    <div :style="circleStyle" class="discovery-stats-chart-legend__circle" />
    <span class="discovery-stats-chart-legend__title">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'DiscoveryStatsChartLegend',
  props: {
    color: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isActive: Boolean,
  },
  computed: {
    circleStyle() {
      return {
        background: this.color,
      };
    },
  },
};
</script>

<style lang="scss">
.discovery-stats-chart-legend {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  transition-duration: 0.2s;
  color: #9da0af;

  &--inactive {
    opacity: 0.2;
  }

  &__title {
    padding: 0 $global-padding;
  }

  &__circle {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
}
</style>
